// extracted by mini-css-extract-plugin
export default {"formInput":"Verification_formInput__DkSvq","otpInput":"Verification_otpInput__UeIWd","goBackButton":"Verification_goBackButton__1Obyk"};